import { connectIRacingAccount } from '@/actions/iracing/connect-account'
import { getSteamUser } from '@/actions/steam/get-steam-user'
import DiscordIcon from '@/components/icons/logos/discord'
import SteamIcon from '@/components/icons/logos/steam'
import set from 'lodash/set'
import Image from 'next/image'

// OAuth supported accounts
const connectedAccountOptions = [
  {
    id: 'iracing',
    nicename: 'iRacing',
    img: {
      src: '/img/iracing/iracing-icon.webp',
    },
    formatAccount: async (searchParams) => {
      const code = searchParams.code
      if (!code) return {} // Should probably throw or handle error
      return await connectIRacingAccount(code)
    },
    displayTmpl: ({ account }) => {
      return (
        <div className="flex items-center gap-2">
          <Image
            src="/img/points-import/iracing-icon.webp"
            alt="iRacing Icon"
            height={50}
            width={50}
          />
          <div className="flex flex-col justify-center">
            <p className="text-p-3 font-semibold">
              {account.serviceAccountName || 'iRacing User'}
            </p>
            <p className="text-p-1">Customer ID: {account.serviceAccountId}</p>
          </div>
        </div>
      )
    },
  },
  // {
  //   id: 'psn',
  //   nicename: 'PlayStation Network',
  //   img: {
  //     src: '/img/service-logos/psn.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  // {
  //   id: 'xbox',
  //   nicename: 'Xbox Live',
  //   img: {
  //     src: '/img/service-logos/xbox.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  {
    id: 'steam',
    nicename: 'Steam',
    img: {
      src: '/img/service-logos/steam.webp',
    },
    formatAccount: async (searchParams) => {
      const account = {
        metadata: {},
      }
      Object.keys(searchParams).forEach((k) => {
        set(account.metadata, k, searchParams[k])
      })

      const steamId = account.metadata.openid.claimed_id.split('/').pop()
      account.metadata.id = steamId

      const steamUser = await getSteamUser(steamId)
      account.metadata.steam = steamUser

      console.log(JSON.stringify(account, null, 2))
      return account
    },
    displayTmpl: ({ account }) => {
      return (
        <div className="flex items-center gap-2">
          <SteamIcon className="h-[50px] w-[50px] fill-white" />
          <div className="flex flex-col justify-center">
            <p className="text-p-3 font-semibold">
              {account.serviceAccountName || 'Steam User'}
            </p>
            <p className="text-p-1">Steam ID: {account.serviceAccountId}</p>
          </div>
        </div>
      )
    },
  },
  // {
  //   id: 'ea',
  //   nicename: 'EA',
  //   img: {
  //     src: '/img/service-logos/ea.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  {
    id: 'ubisoft',
    nicename: 'Ubisoft',
    img: {
      src: '/img/service-logos/ubisoft.webp',
    },
    formatAccount: async (searchParams) => {
      const code = searchParams.code

      // Token request
      const tokenRes = await fetch(
        'https://api.trackmania.com/api/access_token',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `grant_type=authorization_code&client_id=${process.env.UBISOFT_CLIENT_ID}&client_secret=${process.env.UBISOFT_CLIENT_SECRET}&code=${code}&redirect_uri=${process.env.NEXT_PUBLIC_BASE_URL}/account/connect-account/ubisoft`,
        },
      )
      const tokenData = await tokenRes.json()

      // User request
      const userRes = await fetch('https://api.trackmania.com/api/user', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenData.access_token}`,
        },
      })
      const userData = await userRes.json()

      return {
        metadata: {
          ubisoft: userData,
          id: userData.accountId,
        },
      }
    },
    displayTmpl: ({ account }) => {
      return (
        <div className="flex items-center gap-2">
          <Image
            src="/img/points-import/ubisoft-icon.webp"
            alt="Ubisoft Icon"
            height={50}
            width={50}
          />
          <div className="flex flex-col justify-center">
            <p className="text-p-3 font-semibold">
              {account.serviceAccountName || 'Ubisoft User'}
            </p>
            <p className="text-p-1">{account.serviceAccountId}</p>
          </div>
        </div>
      )
    },
  },
  // Discord one is using the user object in db rather than connected account...
  // TODO this should realisitcally be handled differently but due to legacy we are storing discord info on the user object
  {
    id: 'discord-link',
    nicename: 'Discord',
    img: {
      src: '/img/LinkImages/Discord.webp',
    },
    formatAccount: async (searchParams) => {},
    displayTmpl: ({ user }) => {
      return (
        <div className="flex items-center gap-2">
          <DiscordIcon className="h-[50px] w-[50px] fill-white" />
          <div className="flex flex-col justify-center">
            <p className="text-p-3 font-semibold">
              {user.discordUsername ? user.discordUsername : user.discordUserId}
            </p>
            {user.discordUsername ? (
              <p className="text-p-1">{user.discordUserId}</p>
            ) : (
              <></>
            )}
          </div>
        </div>
      )
    },
  },
  // {
  //   id: 'epic',
  //   nicename: 'Epic',
  //   img: {
  //     src: '/img/service-logos/epic.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  // {
  //   id: 'nintendo',
  //   nicename: 'Nintendo',
  //   img: {
  //     src: '/img/service-logos/nintendo.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  // {
  //   id: 'google',
  //   nicename: 'Google',
  //   img: {
  //     src: '/img/service-logos/google.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     const result = await apiGet({
  //       fullUrl: 'https://openidconnect.googleapis.com/v1/userinfo',
  //       headers: {
  //         Authorization: `Bearer ${searchParams.code}`,
  //       },
  //     })

  //     console.log(
  //       '%cTEST ->\n\tresult[%s]: %O',
  //       'font-size: 14px; color: #DC143C;',
  //       typeof result,
  //       JSON.stringify(result, null, 2),
  //     )

  //     return {
  //       metadata: {
  //         openid: searchParams,
  //       },
  //     }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  // {
  //   id: 'apple',
  //   nicename: 'Apple',
  //   img: {
  //     src: '/img/service-logos/apple.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  // {
  //   id: 'facebook',
  //   nicename: 'Facebook',
  //   img: {
  //     src: '/img/service-logos/facebook.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
  // {
  //   id: 'x',
  //   nicename: 'X',
  //   img: {
  //     src: '/img/service-logos/x.webp',
  //   },
  //   formatAccount: async (searchParams) => {
  //     return { metadata: searchParams }
  //   },
  //   displayTmpl: ({ account }) => {
  //     return 'Connected...'
  //   },
  // },
]

export default connectedAccountOptions
